var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMutualFund(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 12.6668H14.924C14.4925 12.6322 14.0674 12.7887 13.7613 13.0948C13.4552 13.4009 13.2987 13.826 13.3333 14.2575C13.3333 16.0002 18.6667 17.3335 18.6667 19.0762C18.6743 19.5003 18.5092 19.9094 18.2092 20.2094C17.9092 20.5094 17.5002 20.6745 17.076 20.6668H13.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6667V10.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6667V20.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.3335V20.6668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.66675C17.1046 4.66675 18 3.77132 18 2.66675C18 1.56218 17.1046 0.666748 16 0.666748C14.8954 0.666748 14 1.56218 14 2.66675C14 3.77132 14.8954 4.66675 16 4.66675Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.3335C5.10457 11.3335 6 10.4381 6 9.3335C6 8.22893 5.10457 7.3335 4 7.3335C2.89543 7.3335 2 8.22893 2 9.3335C2 10.4381 2.89543 11.3335 4 11.3335Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24.6667C5.10457 24.6667 6 23.7713 6 22.6667C6 21.5622 5.10457 20.6667 4 20.6667C2.89543 20.6667 2 21.5622 2 22.6667C2 23.7713 2.89543 24.6667 4 24.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 11.3335C29.1046 11.3335 30 10.4381 30 9.3335C30 8.22893 29.1046 7.3335 28 7.3335C26.8954 7.3335 26 8.22893 26 9.3335C26 10.4381 26.8954 11.3335 28 11.3335Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 24.6667C29.1046 24.6667 30 23.7713 30 22.6667C30 21.5622 29.1046 20.6667 28 20.6667C26.8954 20.6667 26 21.5622 26 22.6667C26 23.7713 26.8954 24.6667 28 24.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31.3335C17.1046 31.3335 18 30.4381 18 29.3335C18 28.2289 17.1046 27.3335 16 27.3335C14.8954 27.3335 14 28.2289 14 29.3335C14 30.4381 14.8954 31.3335 16 31.3335Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.748 23.6387L14.252 28.3613",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.748 28.3613L26.252 23.6387",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.6668V11.3335",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.252 8.36134L17.748 3.63867",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.252 3.63867L5.748 8.36134",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualFund);
export default __webpack_public_path__ + "static/media/mutual-fund.60fa12cdd010de48bf9c3cb76ff51a40.svg";
export { ForwardRef as ReactComponent };